import { render, staticRenderFns } from "./CubusDashboard.vue?vue&type=template&id=6bcb0b85"
import script from "./CubusDashboard.vue?vue&type=script&lang=js"
export * from "./CubusDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports